define('esteira-locacao-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function () {
    var app = angular.module('esteira.locacao.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
    app.factory('EsteiraLocacao', ['$q', '$http', '$location', '$state', 'i18n', 'appRoute', 'notify',
        function ($q, $http, $location, $state, i18n, appRoute, notify, $multipart) {
            return {
                getProfissoes: function (filtro) {
                    return $q(function (resolve, reject) {
                        return $http({
                            url: appRoute.linkTo('default.apiGetProfession'),
                            method: 'GET',
                            params: { profNome: filtro }
                        }).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },


                getEnderecoPorCep: function (cep) {
                    return $q(function (resolve, reject) {
                        return $http.get(appRoute.linkTo('default.apiBuscarEnderecoPorCEP', cep)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                getDocumentosEsteira: function (esteira_id) {
                    return $q(function (resolve, reject) {
                        return $http.get(appRoute.linkTo('esteiraLocacao.getDocumentosEsteira', esteira_id)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                getDocumentosFiador: function ({esteira_id, fiador_id}) {
                    return $q(function (resolve, reject) {
                        return $http.get(appRoute.linkTo('esteiraLocacao.getDocumentosFiador', `${esteira_id}/${fiador_id}`)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                sendEmailDocEnviado: function (esteira_id) {
                    return $q(function (resolve, reject) {
                        return $http.get(appRoute.linkTo('esteiraLocacao.sendEmailDocEnviado', esteira_id)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                deleteDocEsteira: function (documento) {
                    return $q(function (resolve, reject) {
                        return $http.delete(appRoute.linkTo('esteiraLocacao.deleteDocEsteira', `${documento.es_codigo}/${documento.ed_codigo}`)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },


                deleteDocFiador: function (documento) {
                    return $q(function (resolve, reject) {
                        return $http.delete(appRoute.linkTo('esteiraLocacao.deleteDocFiador', `${documento.es_codigo}/${documento.ef_codigo}/${documento.edf_codigo}`)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                deleteFiador: function (fiador) {
                    return $q(function (resolve, reject) {
                        return $http.delete(appRoute.linkTo('esteiraLocacao.deleteFiador', `${fiador.es_codigo}/${fiador.ef_codigo}`)).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            reject(error);
                        });
                    });
                },

                createEsteira: function (form) {
                    return $q(function (resolve, reject) {
                        $http.post(appRoute.linkTo('esteiraLocacao.create'), form).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            if (error && error.notifications && !_.isEmpty(error.notifications)) {
                                notify.addNotification(error.notifications);
                            } else {
                                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
                            }
                            reject(error);
                        });
                    });
                },
                saveFiador: function (form) {
                    return $q(function (resolve, reject) {
                        $http.post(appRoute.linkTo('esteiraLocacao.saveFiador'), form).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            if (error && error.notifications && !_.isEmpty(error.notifications)) {
                                notify.addNotification(error.notifications);
                            } else {
                                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
                            }
                            reject(error);
                        });
                    });
                },
                retirarChavesEsteira: function (form) {
                    return $q(function (resolve, reject) {
                        $http.post(appRoute.linkTo('esteiraLocacao.retirarChavesEsteira'), form).success(function (data) {
                            resolve(data);
                        }).error(function (error) {
                            if (error && error.notifications && !_.isEmpty(error.notifications)) {
                                notify.addNotification(error.notifications);
                            } else {
                                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
                            }
                            reject(error);
                        });
                    });
                },


                // /imob/profissoes
            }
        }
    ]);
});


